import React from "react";
import '../Styles/IndividualsAccountDashboard.scss';
import IndividualRegistrationPaymentInformation from "../Components/IndividualRegistrationPaymentInformation";
import DateHelpers from "../Helper/DateHelpers";
import RegistrationCardList from "../Components/RegistrationCardList";
import InputValidation from "../Helper/InputValidation";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from "react-router-dom";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Navbar from '../Components/Navbar';
import { Helmet } from "react-helmet";
import format from 'date-fns/format';
import { AutoScrollService } from "ag-grid-community";
import Session from 'react-session-api';

function IndividualsAccountDashboard() {

   const [camperInformation, setCamperInformation] = useState()
   const [accountInformation, setAccountInformation] = useState()
   const [firstName, setFirstName] = useState()
   const navigate = useNavigate()

   // Rename response 2 to a better name
   const getCamperInformation = async () => {
      try {
         const individualAccountResponse = await fetch('/api/get-user', {
            method: 'GET',
            headers: { "Content-Type": "application/json" }
         })

         if (individualAccountResponse.status === 400 || individualAccountResponse.status === 401 || individualAccountResponse.status === 500) {
            Session.set("isAuth", null)
            Session.set("accountType", null)
            navigate('/')
            throw new Error("Failed User Retrieval");
         }

         const account = await individualAccountResponse.json();
         console.log("Account", account)

         const response = await fetch('/getindividualregistrations', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               email: account.account.email_address,
               id: account.account.account_id
            })
         })
         const queryResponse = await response.json();
         console.log("Here is camper information", queryResponse.data)
         // console.log("error testing", registrations.data.individualData[0].first_name)

         // setFirstName(registrations.data.individualData[0].first_name)
         // setEmail(account.account.rows[0].email_address)
         // setRowData({ IndividualData: registrations.data.individualData, registrationData: registrations.data.registrationData })
         setCamperInformation(queryResponse.data.camperInformation)
         setAccountInformation(queryResponse.data.accountInformation)
      } catch (err) {
         console.error(err.message);
      }
   }

   useEffect(() => {
      getCamperInformation()
   }, [])

   useEffect(() => {
      if (!camperInformation) {
         return
      }
      setFirstName(accountInformation[0].first_name)
   }, [accountInformation])

   // Drives whether the payment button appears at all, and what it says. Display only — the amount
   // actually charged is recalculated server-side on the payment page.
   const totalAmountDue = (camperInformation ?? []).reduce(
      (sum, registration) => sum + Number(registration.registration_amount_due ?? 0), 0
   )

   return (
      <div>
         <div className="NavBar">
            <Navbar />
         </div>
         <div className="individualAccountContent">
            <div className="individualAccountContainer">
               <div className='individualAccountHeading'>
                     Welcome, {firstName}
               </div>

               <div className="individualAccountRegistrations">
                  <div className='individualAccountRegistrationsHeading'>
                     <>My Registrations</>
                  </div>
                  <div className="individualAccountRegistrationsList">
                     <RegistrationCardList
                        queriedRegistrations={camperInformation} />
                  </div>
               </div>
               <div className="registerForNewEvent">
                  {/* One payment covering every registration that still owes, on its own page,
                      rather than a button on each card. Only offered when something is owed. */}
                  {totalAmountDue > 0 &&
                     <div className="individualAccountPaymentButton">
                        <Link to={'/makepayment'}>
                           <button>
                              Make a Payment (${totalAmountDue.toFixed(2)} due)
                           </button>
                        </Link>
                     </div>
                  }
                  <div className="individualRegistrationButton">
                     <Link to={'/registrationcampselection'}>
                        <button>
                           Register For a New Event
                        </button>
                     </Link>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default IndividualsAccountDashboard;
